import React from 'react'
import { withFirebase } from '../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const Logout = ({ firebase }) => {
    return (

        <button className="dropdown-item" onClick={firebase.doSignOut} >
            <FontAwesomeIcon className="mr-1" icon={faSignOutAlt} />
            Cerrar Sesión
        </button>
    );
}

export default withFirebase(Logout);